import { useAddSpaceModal } from "@circle-react/components/Modals/AddSpaceModal";
import { useSpaceGroupsContext } from "@circle-react/contexts";

export const useAddCourse = () => {
  const addSpaceModal = useAddSpaceModal();
  const { records: spaceGroups } = useSpaceGroupsContext();

  return () => {
    addSpaceModal.show({
      postType: "course",
      spaceGroupId: spaceGroups?.[0].id,
    });
  };
};
